import React, { useEffect, useState } from "react";
import ChatBox from "./chatBox.js";
import ChatInput from "./chatInput.js";
import ChatHeader from "./chatHeader.js";

const ChatPage = () => {
  const [messages, setMessages] = useState([]);
  const socket = new WebSocket("ws://localhost:8080");

  useEffect(() => {
    socket.onmessage = (event) => {
      setMessages((prev) => [...prev, JSON.parse(event.data)]);
    };
  }, []);

  const sendMessage = (text) => {
    const msg = {
      message: text,
      sender_type: "customer",
      time: new Date().toLocaleTimeString(),
    };
    socket.send(JSON.stringify(msg));
    setMessages((prev) => [...prev, msg]);
  };

  return (
    <div className="chat-container">
      <ChatHeader name="Vendor Support" status="online" />
      <ChatBox messages={messages} userType="customer" />
      <ChatInput onSend={sendMessage} />
    </div>
  );
};

export default ChatPage;
